export default "__VITE_ASSET__DOLRCPe3__"